import React from "react";

import PaginaFotos from "../../../components/Fotos/PaginaFotos/index";

export default function Tratadas() {

    return (<> <PaginaFotos titulo={"Tratadas"} diretorio={"tratadas"} /> </>);
}
